import React, { Component } from "react";
import ReactTable from "react-table";
import { DropdownButton, Dropdown, Button, Container, Row, Col } from "react-bootstrap";
import autoBind from 'react-autobind';
//
import CustomComponent from "./../components/CustomComponent";
import CustomNavigationController from './../components/CustomNavigationController';
import Utils from "./../components/Utils";
import CommonLogFilter from "./subviews/CommonLogFilter";
import CommonLogTable from "./subviews/CommonLogTable";
import CommonLoadingView from "./subviews/CommonLoadingView";
//
//import "./../stylesheets/admSubmissions.css";
//
export default class AdminReportHistory extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this,"handleRowClick","handleFilterSubmit","fetchData");
    //
    this.state = {error: false, data: [], firstLoad: true, isLoading: false};
  }
  loadResponse(response) {
    if (response['data'] != null) { //valid data state
      this.state.data = response['data'];
      this.state.firstLoad =  false;
    }else { //non-valid data state
      if (response["errorData"]) this.props.alertController.showErrorAlert("Error!","",response);
      this.state.data = [];
      this.state.firstLoad =  false;
    } this.setState(this.state);
  }
  async componentDidMount() {
    if (this.state.firstLoad) this.fetchData();
  }
  //API
  fetchData() {
    this.startLoading();
    this.props.app.sharedAPIWrapper().fetchMonthlyReportsApproved(this.filterObj.getFilters(), response => {
      if (!this._isMounted) return;
      this.stopLoading();
      this.loadResponse(response);
    });
  }
  //Utils
  startLoading() {
    this.state.isLoading = true;
    this.setState(this.state);
  }
  stopLoading() {
    this.state.isLoading = false;
    this.setState(this.state);
  }
  //Actions
  handleFilterSubmit() {
    this.fetchData();
    this.filterObj.disableAction();
  }
  handleRowClick(event, row) {
    this.props.navigationController.pushView(
      <CommonLogTable reportMR={row.original} app={this.props.app}
                       alertController={this.props.alertController}/>
    );
  }
  //UI
  render() {
    const data = (this.state.data == null ? [] : this.state.data);
    const props = {
      showPagination: false,
      minRows: 6,
      noDataText: "No reports!",
      loadingText: "Loading...",
      keyField :'pk',
      loading:this.state.isLoading,
      getTrProps: (s, r) => {
        const selected = true;
        return {
          onClick: (e) => { this.handleRowClick(e, r) },
        };
      }
    };
    const columns = [
    {
      Header: 'Submission Year',
      accessor: d => (d['sk'] ? d['sk'].slice(0,4) : ""),
      id: "sky"
    },{
      Header: 'Submission Month',
      id: 'skm',
      accessor: d => Utils.getMonthName(d['sk'] ? d['sk'].slice(4,6) : "")
    },{
      Header: 'Advisor Name',
      id: 'pku',
      accessor: d => (d['pk'] ? this.props.app.sharedCache().findUserNameByID(d["pk"].replace("MS::","")) : "")
    },{
      Header: 'Total Costs($)',
      accessor: 'totalclaim'
    },{
      Header: 'Status',
      accessor: 'gsi1sk'
    }];
    //render
    return (
    <div className="AppPageContainer">
      <CommonLoadingView isLoading={this.state.isLoading}/>
      <CommonLogFilter app={this.props.app}
                       handleFilterSubmit={this.handleFilterSubmit}
                       ref={c => (this.filterObj = c)}/>
      <ReactTable data={data} className="v-100 -highlight" columns={columns} {...props} />
    </div>);
  }
}
//Navigation container implementation
export class AdminReportHistoryNavigationController extends CustomNavigationController {
  constructor(props) {
    super(props);
    this.containerClass = AdminReportHistory;
  }
}
